<template>
    <div id="organizationStructure">
        <div class="orgLeft" :style="myAutoContent">
            <el-container style="height:100%;width:100%">
                <el-header style="height:auto;margin-top:14px;margin-bottom:1px">
                    <el-input placeholder="输入关键字进行过滤" v-model.trim="filterText" style="width:220px;"></el-input>
                    <el-button type="text" style="margin-left:5px" @click="openEditDlg('','','topAdd')">
                        <i class="fa fa-plus fa-lg"></i>
                    </el-button>
                </el-header>

                <el-main style="height:100%;width:100%;">
                    <el-tree :props="defaultProps" node-key="id" :data="returnData" accordion :expand-on-click-node="false" ref="tree2" @node-click="handleNodeClick" :filter-node-method="filterNode" :default-expanded-keys="showKeyArray" :highlight-current="true" class="treeClass">
                        <span class="custom-tree-node" slot-scope="{ node, data }" style="font-size:14px;">
                            <span v-if="data.parentId==0">
                                <span class="fa fa-folder-open fa-fw" :title="node.label">{{node.label | ellipsis}}</span>
                            </span>
                            <span v-else-if="data.parentId==1">
                                <span class="fa fa-folder-open-o fa-fw" :title="node.label">{{node.label | ellipsis}}</span>
                            </span>
                            <span v-else>
                                <span class="fa fa-folder-o fa-fw" :title="node.label">{{node.label | ellipsis}}</span>
                            </span>
                            <span v-if="data.parentId==0">
                                <el-button type="text" size="mini" @click.stop="() => openEditDlg(data.id,data,'topEdit')">
                                    <i class="fa fa-edit fa-lg"></i>
                                </el-button>
                                <el-button type="text" style="color:red" size="mini" @click.stop="() => deleteOne(data,data.id)">
                                    <i class="fa fa-minus fa-lg"></i>
                                </el-button>
                            </span>
                        </span>
                    </el-tree>
                </el-main>
            </el-container>
        </div>

        <div class="orgRight" :style="myAutoContent">
            <div class="commonSearch" ref="commonSearchRef">
                <el-form class="el-form el-form--inline" onsubmit="return false">
                    <el-form-item v-if="this.returnData.length!=0">
                        <el-button type="primary" plain icon="fa fa-plus fa-lg" @click="openEditDlg('','','')">&nbsp;&nbsp;新增</el-button>
                    </el-form-item>
                    <el-form-item v-if="this.returnData.length!=0">
                        <el-button type="danger" plain icon="el-icon-delete" @click="deleteMore">&nbsp;&nbsp;删除</el-button>
                    </el-form-item>
                    <el-form-item label="所属系统" class="head-right">
                        <el-select v-model="systemId" placeholder="请选择系统" clearable @change="changePlatform">
                            <el-option v-for="item in systemIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <div style="clear:both"></div>
                </el-form>
            </div>
            <div class="myTable">
                <el-table :data="nextChildrenData" style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange" @select="handleSelect" @select-all="handleSelection" v-loading="loading" element-loading-text="拼命加载中" size="medium" :height="myTabHeight">
                    <el-table-column type="selection" width="55" @selection-change="handleSelectionChange"></el-table-column>

                    <el-table-column prop="name" label="名称" min-width="150" align="left"></el-table-column>
                    <el-table-column prop="rightValue" label="权限值" min-width="150" align="left"></el-table-column>
                    <el-table-column prop="sortId" label="排序号" align="left" width="100"></el-table-column>
                    <el-table-column label="操作" width="110" align="left">
                        <template slot-scope="scope">
                            <i style="cursor:pointer" type="primary" class="fa fa-edit fa-2x btnColor" @click="openEditDlg(scope.$index,scope.row,'')" title="编辑"></i>
                            <i style="margin-left:10px;cursor:pointer" class="fa fa-times-circle-o fa-2x btnColor" @click="deleteOne(scope.row,scope.row.id)" title="删除"></i>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 分页框 -->
        <div class="commonPage">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="cur_page" :page-sizes="[5, 10, 15, 30]" layout="total, sizes, prev, pager, next, jumper" :total="totalCount" :disabled="loading"></el-pagination>
        </div>

        <div>
            <EditDlg v-if="editDlgShow" ref="editDlgRef"></EditDlg>
        </div>
    </div>
</template>

<script>
import EditDlg from "./PowerManageEditDlg.vue";
import TabResize from "@/utils/TabResizeEx.js";
import Utils from "@/utils/Utils.js";
import SettingApi from "@/api/setting.js";

export default {
    filters: {
        ellipsis (value) {
            if (!value) return "";
            if (value.length > 10) {
                return value.slice(0, 10) + "...";
            }
            return value;
        }
    },
    mixins: [TabResize],
    components: {
        EditDlg
    },
    mounted: function () {
        //初始化
        this.loading = false;
        this.$nextTick(() => {
            this.myAutoContent.height = this.myAutoContentHeight + "px";
            this.myTabHeight = this.myAutoContentInnerHeight + "px";
            this.onloadGroup();
            this.loadSystems();
        });
        if (this.$constant.DEV_MODE) {
            console.log("-- OrganizationStructure addEventListener  resize ---");
        }
        window.addEventListener("resize", this.$mainResize);
    },
    computed: {
        myAutoContentHeight () {
            return this.getMyAutoContentHeight();
        },
        myAutoContentInnerHeight () {
            return this.getMyAutoContentInnerHeight();
        },
        $mainResize () {
            return _.debounce(() => {
                if (this.myAutoContent.height) {
                    this.myAutoContent.height = this.getMyAutoContentHeight() + "px";
                    this.myTabHeight = this.getMyAutoContentInnerHeight() + "px";
                } else {
                    if (this.$constant.DEV_MODE) {
                        console.log(" this.myAutoContentHeight 不存在");
                    }
                }
            }, 400);
        }
    },
    deactivated () {
        if (this.$constant.DEV_MODE) {
            console.log("-- OrganizationStructure removeEventListener  resize ---");
        }
        window.removeEventListener("resize", this.$mainResize);
    },
    data () {
        return {
            myAutoContent: {
                height: "600px",
                "overflow-y": "auto"
            },
            systemId: this.$constant.CATALOG,
            systemIdList: [],
            currentNode: null,
            currentNodeType: 0,
            currentNodeId: 0,
            myTabHeight: 400,
            myTabHeight: 400,
            defaultProps: {
                children: "subs",
                label: "name",
                isLeaf: "leaf"
            },
            returnData: [],
            cacheData: {},
            filterText: "",
            editDlgShow: false,
            loading: true,
            showKeyArray: [],
            nextChildrenData: [],
            cur_page: 1,
            multipleSelection: [],
            select_word: "",
            parentId: "",
            totalCount: 0,
            per_page: this.$constant.PAGE_SIZE
        };
    },
    watch: {
        filterText (val) {
            this.$refs.tree2.filter(val);
        }
    },
    methods: {
        getMyAutoContentHeight () {
            let defTagsHeight = this.$constant.DEF_TAGS_HEIGHT;
            let defSearchHeight = 0;
            let defHomeHeight = 600;

            if (this.$refs.commonSearchRef) {
                defSearchHeight = this.$refs.commonSearchRef.clientHeight;
            }
            if (this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef) {
                defTagsHeight = this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef
                    .clientHeight;
            }

            defHomeHeight =
                window.innerHeight -
                this.$constant.DEF_HEADER_HEIGHT -
                defTagsHeight -
                this.$constant.DEF_PADDING_HEIGHT -
                defSearchHeight;
            return defHomeHeight;
        },
        getMyAutoContentInnerHeight () {
            let autoContentHeight = this.getMyAutoContentHeight();
            let defHomeHeight = 400;
            let defOperHeight = 47;
            if (this.$refs.commonOperBtnRef) {
                defOperHeight = this.$refs.commonOperBtnRef.clientHeight;
            }
            defHomeHeight = autoContentHeight - defOperHeight;
            return defHomeHeight;
        },
        filterNode (value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        onloadGroup () {
            let param = {
                catalog: this.systemId
            };
            SettingApi.getClass()
                .onloadRightGroup(param)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        if (res2.data.data != null) {
                            this.returnData = res2.data.data;
                            this.showKeyArray = [];
                            this.showKeyArray.push(res2.data.data.id);
                            if (this.parentId == "" || this.parentId == null) {
                                this.parentId = res2.data.data[0].id;
                                this.parentName = res2.data.data[0].name;
                                this.$nextTick(() => {
                                    this.$refs.tree2.setCurrentKey(res2.data.data[0].id);
                                });
                                this.getListData(res2.data.data[0].id);
                            } else {
                                this.$nextTick(() => {
                                    this.$refs.tree2.setCurrentKey(this.parentId);
                                });
                                // this.getListData(this.parentId);
                            }
                        } else {
                            this.returnData = [];
                        }
                    } else {
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },
        getListData (id) {
            this.loading = true;
            let param = {
                id: id,
                pageNum: this.cur_page,
                pageSize: this.per_page,
                catalog: this.systemId
            };
            SettingApi.getClass()
                .getRightListData(param)
                .then(res2 => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        let data = res2.data.data;
                        this.totalCount = data.totalElements;
                        this.nextChildrenData = data.data;
                        // if (data.totalPages < this.cur_page && data.totalElements > 0) {
                        //   this.cur_page = data.totalPages;
                        //   this.refreshData();
                        // }
                        this.initSelect();
                        this.loading = false;
                    } else {
                        this.$message.error(res2.data.msg);
                        this.loading = false;
                        return false;
                    }
                })
                .catch(err => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },
        handleNodeClick (data, node, vuecomponent) {
            // console.log(
            //   "data:",
            //   data,
            //   "\n",
            //   "node:",
            //   node,
            //   "\n",
            //   "vuecomponent",
            //   vuecomponent
            // );
            this.parentId = data.id;
            this.parentName = data.name;
            this.getListData(data.id);
        },

        //获取选中行
        handleSelectionChange (val) {
            this.multipleSelection = val;
        },
        handleSelect (selection, row) {
            this.cacheData[this.cur_page] = selection;
        },
        handleSelection (selection) {
            this.cacheData[this.cur_page] = selection;
        },
        initSelect () {
            for (let prop in this.cacheData) {
                if (prop == this.cur_page) {
                    if (this.cacheData[prop] && this.cacheData[prop].length > 0) {
                        this.$nextTick(() => {
                            this.checkIsSelected(this.cacheData[prop]);
                        });
                    }
                }
            }
        },
        checkIsSelected (selectedData) {
            this.nextChildrenData.forEach(element => {
                selectedData.forEach(el => {
                    if (el.id == element.id) {
                        this.$refs.multipleTable.toggleRowSelection(element, true);
                    }
                });
            });
        },
        openEditDlg (index, row, level) {
            this.editDlgShow = true;
            let operateFlag = "";
            let param = {
                parentId: this.parentId,
                parentName: this.parentName,
                systemId: this.systemId
            };
            if (row != null && row != "") {
                operateFlag = "update";
                this.$nextTick(() => {
                    this.$refs.editDlgRef.init(param, row, operateFlag, level);
                });
            } else if (level == "topAdd") {
                operateFlag = "topAdd";
                this.$nextTick(() => {
                    this.$refs.editDlgRef.init(param, "", operateFlag, level);
                });
            } else {
                operateFlag = "add";
                this.$nextTick(() => {
                    this.$refs.editDlgRef.init(param, "", operateFlag, level);
                });
            }
        },
        deleteOne (data, id) {
            if (data.subs != null && data.subs.length > 0) {
                this.$message.error("存在子节点，无法删除。");
                return;
            }
            let list = [];
            list.push(id);
            let param = {
                ids: list
            };
            this.deleteData(param);
        },
        deleteMore () {
            let idList = new Array();
            if (this.multipleSelection.length == 0) {
                this.$message.error("请至少选择一条要删除的数据！");
                return false;
            }
            for (let i = 0; i < this.multipleSelection.length; i++) {
                idList[i] = "" + this.multipleSelection[i]["id"];
            }
            let param = {
                ids: idList
            };
            this.deleteData(param);
        },
        deleteData (param) {
            this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.loading = true;
                    SettingApi.getClass()
                        .deleteRightById(param)
                        .then(res2 => {
                            if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                                this.$message.success("删除成功！");
                                this.cacheData[this.cur_page] = {};
                                this.loading = false;
                                this.refreshData();
                            } else {
                                this.$message.error(res2.data.msg);
                                this.loading = false;
                                return false;
                            }
                        })
                        .catch(err => {
                            this.$message.error(err);
                            this.loading = false;
                            return false;
                        });
                })
                .catch(() => { });
        },
        handleSizeChange (val) {
            this.per_page = val;
            this.cur_page = 1;
            this.loading = true;
            this.getListData(this.parentId);
        },
        // 切换显示第几页
        handleCurrentChange (val) {
            this.cur_page = val;
            this.loading = true;
            this.getListData(this.parentId);
        },
        initDataBySearch () {
            this.cur_page = 1;
            this.getListData(this.parentId);
        },
        loadSystems () {
            SettingApi.getClass()
                .loadSystems()
                .then(res => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
                        this.systemIdList = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err);
                });
        },
        changePlatform () {
            this.parentId = "";
            this.onloadGroup();
        },
        refreshData () {
            let length = this.multipleSelection.length;
            if (length == null || length == "") {
                length = 1;
            }
            let m = Math.ceil((this.totalCount - length) / this.per_page);
            if (this.cur_page > 1 && this.cur_page > m) {
                this.cur_page = this.cur_page - 1;
            }
            this.onloadGroup();
            this.getListData(this.parentId);
        }
    }
};
</script>


<style lang="stylus" scoped>
#organizationStructure {
    width: 100%;

    .orgLeft {
        width: $dept-left-width;
        margin-left: $content-margin-left;
        float: left;
        background-color: white;
        border-radius: $border-radius;
        box-shadow: $box-shadow;
    }

    .orgRight {
        margin-top: $content-margin-top;
        background-color: white;
        width: auto;
        margin-right: $content-margin-right;
        margin-left: $dept-left-margin;
        border-radius: $border-radius;
        box-shadow: $box-shadow;
    }
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}

.head-right {
    float: right;
}

.btnColor {
    color: $theme-color;
}

.treeClass >>> .el-tree-node__children {
    overflow: inherit !important;
}

.treeClass >>> .el-tree-node__content {
    width: 100%;
}
</style>

